
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("6t3Wv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "BackgroundScriptsUnsafe", () => $a26fb8b0f5315a6a$export$3272d86409535c78);
$parcel$export(module.exports, "BackgroundScripts", () => $a26fb8b0f5315a6a$export$5a06b2ee660255d9);
$parcel$export(module.exports, "default", () => $a26fb8b0f5315a6a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $01Qi5 = parcelRequire("01Qi5");

var $0cdA8 = parcelRequire("0cdA8");

var $bBGpO = parcelRequire("bBGpO");

var $5syGA = parcelRequire("5syGA");

var $loaa7 = parcelRequire("loaa7");

var $gGtKh = parcelRequire("gGtKh");

var $01Qi5 = parcelRequire("01Qi5");

var $6MAb5 = parcelRequire("6MAb5");

var $hEvdQ = parcelRequire("hEvdQ");

var $pljWC = parcelRequire("pljWC");
const $a26fb8b0f5315a6a$export$3272d86409535c78 = ()=>{
    const { data: forgeData } = (0, $01Qi5.useDashboardForgeResource)();
    const { data: dashboardData } = (0, $01Qi5.useDashboardResource)();
    const analyticsAttributes = (0, $eUqFw.useCallback)(()=>(0, $bBGpO.createAttributes)(), []);
    const dashboardId = dashboardData?.id;
    const backgroundScriptsCombined = (0, $eUqFw.useMemo)(()=>(0, $6MAb5.getScriptsForTheInstalledGadgets)({
            gadgets: dashboardData?.gadgets || [],
            connectBackgroundScripts: dashboardData?.backgroundScripts || [],
            forgeBackgroundScripts: forgeData?.backgroundScripts || []
        }), [
        dashboardData?.gadgets,
        dashboardData?.backgroundScripts,
        forgeData?.backgroundScripts
    ]);
    const hasScripts = backgroundScriptsCombined.length > 0;
    if (false || !hasScripts || dashboardId == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "background-scripts-unsafe",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a26fb8b0f5315a6a$var$Container, null, backgroundScriptsCombined.map((script)=>{
        switch(script.type){
            case 'forge':
                {
                    const module = script.item;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $loaa7.AnalyticsWrapper), {
                        attributes: {
                            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(script.item)
                        },
                        key: `${module.id}_${module.properties.resourceUploadId}`
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $pljWC.ForgeBackgroundScript), {
                        item: module
                    }));
                }
            case 'connect':
                {
                    const { appKey: appKey, moduleKey: moduleKey } = script.item;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hEvdQ.ConnectBackgroundScript), {
                        key: `connect-iFrame-${appKey}-${moduleKey}`,
                        id: "connect",
                        packageName: "dashboardBackgroundScript",
                        item: script.item,
                        analytics: analyticsAttributes()
                    });
                }
            default:
                return null;
        }
    })));
};
const $a26fb8b0f5315a6a$export$5a06b2ee660255d9 = ()=>{
    const getAttributes = (0, $eUqFw.useCallback)((error)=>(0, $bBGpO.createAttributes)({
            error: error
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "background-scripts",
        packageName: "jiraDashboardBackgroundScripts",
        teamName: "smite",
        fallback: "unmount",
        attributes: getAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a26fb8b0f5315a6a$export$3272d86409535c78, null));
};
var $a26fb8b0f5315a6a$export$2e2bcd8739ae039 = $a26fb8b0f5315a6a$export$5a06b2ee660255d9;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a26fb8b0f5315a6a$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("loaa7", function(module, exports) {

$parcel$export(module.exports, "AnalyticsWrapper", () => $2298dc37d625d266$export$63b55d605f8a2340);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $1boRu = parcelRequire("1boRu");
const $2298dc37d625d266$export$63b55d605f8a2340 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.DASHBOARD_BACKGROUND_SCRIPT_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });

});

parcelRegister("6MAb5", function(module, exports) {

$parcel$export(module.exports, "getScriptsForTheInstalledGadgets", () => $6d0dc84dfa5041e3$export$e510c3fd0871c515);

var $70ON1 = parcelRequire("70ON1");
const $6d0dc84dfa5041e3$var$transformConnectItem = ({ iframe: { addonKey: addonKey, moduleKey: moduleKey, options: options } })=>({
        appKey: addonKey,
        moduleKey: moduleKey,
        options: typeof options === 'string' ? JSON.parse(options) : options
    });
const $6d0dc84dfa5041e3$export$e510c3fd0871c515 = ({ gadgets: gadgets, connectBackgroundScripts: connectBackgroundScripts, forgeBackgroundScripts: forgeBackgroundScripts })=>{
    const forgeApps = new Set();
    const connectApps = new Set();
    gadgets.forEach((item)=>{
        if (item.forge?.key != null) forgeApps.add((0, $70ON1.getSameEnvAppIdFromExtensionId)(item.forge.key));
        else if (item.connect?.addonKey != null) connectApps.add(item.connect.addonKey);
    });
    return [
        ...forgeBackgroundScripts.map((item)=>({
                type: 'forge',
                item: item
            })),
        ...connectBackgroundScripts.filter((item)=>connectApps.has(item.iframe.addonKey)).map((item)=>({
                type: 'connect',
                item: $6d0dc84dfa5041e3$var$transformConnectItem(item)
            }))
    ];
};

});

parcelRegister("hEvdQ", function(module, exports) {

$parcel$export(module.exports, "ConnectBackgroundScript", () => $7ab7258f9f2614c1$export$baa59ce4793896aa);

var $eUqFw = parcelRequire("eUqFw");

var $4lxPQ = parcelRequire("4lxPQ");

var $jLerq = parcelRequire("jLerq");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $d6f6c = parcelRequire("d6f6c");
var $bFzGY = parcelRequire("bFzGY");

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
var $9IbuV = parcelRequire("9IbuV");
const $7ab7258f9f2614c1$export$c2649cab647951ba = new (0, $kDfSL.UFOExperience)('connect-background-scripts.load-time', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom
});
const $7ab7258f9f2614c1$export$ab6ba6a7b9f1b2ae = ({ item: item, packageName: packageName, id: id, analytics: analytics })=>{
    const [connectHost, setConnectHost] = (0, $eUqFw.useState)(()=>(0, $4lxPQ.getConnectHost)());
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { appKey: appKey, moduleKey: moduleKey, options: options } = item;
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>({
            appKey: appKey,
            moduleKey: moduleKey,
            ...analytics
        }), [
        analytics,
        appKey,
        moduleKey
    ]);
    (0, $9IbuV.useUFOComponentExperience)($7ab7258f9f2614c1$export$c2649cab647951ba);
    const onLoadingComplete = (0, $eUqFw.useCallback)(()=>{
        $7ab7258f9f2614c1$export$c2649cab647951ba.success();
        (0, $jMP2a.fireScreenAnalytics)(createAnalyticsEvent({}), analyticsAttributes);
    }, [
        analyticsAttributes,
        createAnalyticsEvent
    ]);
    const onTimeout = (0, $eUqFw.useCallback)(()=>{
        $7ab7258f9f2614c1$export$c2649cab647951ba.abort();
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${packageName}.${id} timeout`, analyticsAttributes);
    }, [
        analyticsAttributes,
        createAnalyticsEvent,
        packageName,
        id
    ]);
    (0, $eUqFw.useEffect)(()=>{
        connectHost || (0, $4lxPQ.withConnectHost)((host)=>setConnectHost(host)).catch(()=>{
            $7ab7258f9f2614c1$export$c2649cab647951ba.failure();
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${packageName}.${id} failed`, analyticsAttributes);
        });
    }, [
        connectHost,
        analyticsAttributes,
        createAnalyticsEvent,
        packageName,
        id
    ]);
    if (!connectHost) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jLerq.EcosystemModuleAsync), {
        appKey: appKey,
        moduleKey: moduleKey,
        options: options,
        appName: `${appKey}-${moduleKey}`,
        location: "dashboardBackgroundScript",
        onLoadingComplete: onLoadingComplete,
        onTimeout: onTimeout
    });
};
const $7ab7258f9f2614c1$export$baa59ce4793896aa = ({ id: id, packageName: packageName, item: item, analytics: analytics, ...rest })=>{
    const { appKey: appKey, moduleKey: moduleKey } = item;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        key: `connect-iFrame-${appKey}-${moduleKey}`,
        sourceName: `${packageName}.${id}`,
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
        action: "initialized",
        actionSubject: `${packageName}.${id}`,
        actionSubjectId: `connect-iFrame-${appKey}-${moduleKey}`,
        attributes: {
            appKey: appKey,
            ...analytics
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7ab7258f9f2614c1$export$ab6ba6a7b9f1b2ae, {
        item: item,
        id: id,
        packageName: packageName,
        analytics: analytics
    }));
};

});
parcelRegister("4lxPQ", function(module, exports) {

$parcel$export(module.exports, "withConnectHost", () => $74a29a4beb89f78b$export$970e2411dd8601c8);
$parcel$export(module.exports, "getConnectHost", () => $74a29a4beb89f78b$export$186d423c00af146c);
$parcel$export(module.exports, "isConnectDialogWebItem", () => $74a29a4beb89f78b$export$920fb4b46d4f2eec);

var $3X4Tl = parcelRequire("3X4Tl");
const $74a29a4beb89f78b$export$970e2411dd8601c8 = async (action)=>{
    const connectHost = await (0, $3X4Tl.setupConnectJs)();
    action(connectHost);
};
const $74a29a4beb89f78b$export$186d423c00af146c = ()=>window.connectHost;
const $74a29a4beb89f78b$export$920fb4b46d4f2eec = (classes)=>classes.includes('ap-dialog') || classes.includes('ap-inline-dialog');

});
parcelRegister("3X4Tl", function(module, exports) {

$parcel$export(module.exports, "setupConnectJs", () => $e1d87b293e6b1fa3$export$891414b605e5f038);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");

var $8nDwh = parcelRequire("8nDwh");

const $e1d87b293e6b1fa3$var$installConnectJs = async ()=>{
    await (0, $8nDwh.waitForJQuery)();
    const loader = await (parcelRequire("ds7fh"));
    await loader.performSideEffects();
    return window.connectHost;
};
let $e1d87b293e6b1fa3$var$installConnectJsPromise = null;
const $e1d87b293e6b1fa3$export$891414b605e5f038 = async ()=>{
    // Only pages in the SPA will benefit from modernising connect
    if (window.__SPA__) {
        if ($e1d87b293e6b1fa3$var$installConnectJsPromise === null) $e1d87b293e6b1fa3$var$installConnectJsPromise = $e1d87b293e6b1fa3$var$installConnectJs();
        return $e1d87b293e6b1fa3$var$installConnectJsPromise;
    }
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $2BvS3.loadBridge)({
        name: 'ac/create',
        wrmKeys: [
            'wrc!com.atlassian.plugins.atlassian-connect-plugin:jira-atlassian-connect-resources-v5',
            // Undeclared Dependency: jira/navigation
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar'
        ]
    });
    return window.connectHost;
};

});
parcelRegister("8nDwh", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $57c59c350a2284e3$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "getJQuery", () => $57c59c350a2284e3$export$7232a6dc780f9887);
$parcel$export(module.exports, "getGlobalAP", () => $57c59c350a2284e3$export$fbc82125a6bd8012);
$parcel$export(module.exports, "isObject", () => $57c59c350a2284e3$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "escapeSelector", () => $57c59c350a2284e3$export$c8c0ea01c118c2eb);
$parcel$export(module.exports, "waitForJQuery", () => $57c59c350a2284e3$export$97214de9c546981c);
$parcel$export(module.exports, "ErrorDebugAddonKeys", () => $57c59c350a2284e3$export$d690da9bc8146677);

var $guiFP = parcelRequire("guiFP");

var $8n8Xw = parcelRequire("8n8Xw");
const $57c59c350a2284e3$export$c47913ca32a5c6f7 = (key)=>{
    const metaTag = document.querySelector(`meta[name='ajs-${key}']`);
    return metaTag === null ? undefined : metaTag.getAttribute('content') || undefined;
};
const $57c59c350a2284e3$export$7232a6dc780f9887 = ()=>AJS.$;
const $57c59c350a2284e3$export$fbc82125a6bd8012 = ()=>// In the future, we can add analytics events to know how this can fail to access the global variable.
    // We can improve it to load WRM in async
    // Just to add some context for future reviewers: `window._AP` is the actual Connect module that will no longer be loaded via WRM.
    // Its properties are both appended from modules like the dialog options and the public atlassian-connect-js library.
    window._AP;
const $57c59c350a2284e3$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'function' || typeof obj === 'object' && !!obj;
const $57c59c350a2284e3$export$c8c0ea01c118c2eb = (s)=>{
    if (!s) throw new Error('No selector to escape');
    return s.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, '\\$&');
};
const $57c59c350a2284e3$var$FIVE_MINUTES = 300000;
const $57c59c350a2284e3$export$97214de9c546981c = ()=>new Promise((resolve, reject)=>{
        const interval = setInterval(()=>{
            if (window.AJS?.$) {
                clearInterval(interval);
                resolve();
            }
        }, 10);
        setTimeout(()=>{
            clearInterval(interval);
            (0, $guiFP.default)({
                meta: {
                    id: 'connect-jquery-timeout',
                    packageName: 'jiraConnect'
                },
                error: new Error('Timeout when waiting for jQuery to be available on the page'),
                // this is an extremely common error, so we don't want to spam Sentry with it
                skipSentry: true
            });
            reject();
        }, $57c59c350a2284e3$var$FIVE_MINUTES);
    });
const $57c59c350a2284e3$export$7315c38dc71bd41f = 'com.atlassian.servicedesk.embedded-dev';
const $57c59c350a2284e3$export$cb954c21735b28e4 = 'com.atlassian.servicedesk.embedded';
const $57c59c350a2284e3$export$d690da9bc8146677 = [
    $57c59c350a2284e3$export$cb954c21735b28e4,
    $57c59c350a2284e3$export$7315c38dc71bd41f
];

});
parcelRegister("8n8Xw", function(module, exports) {

$parcel$export(module.exports, "FetchConnectError", () => $54c275f50bd3d999$export$630f7f9a7ae923d1);
$parcel$export(module.exports, "handleConnectError", () => $54c275f50bd3d999$export$a7a3f8c4788fb03d);

var $guiFP = parcelRequire("guiFP");

var $lgAsZ = parcelRequire("lgAsZ");
function $54c275f50bd3d999$var$is4xxError(statusCode) {
    return statusCode ? statusCode >= 400 && statusCode < 500 : false;
}
class $54c275f50bd3d999$export$630f7f9a7ae923d1 extends (0, $lgAsZ.default) {
    constructor(message, statusCode, cause, skipSentry){
        super(message, {
            cause: cause
        });
        // the name is copied from `KNOWN_NETWORK_ERRORS_TYPES` in `src/packages/platform/utils/fetch/src/utils/is-error.tsx`
        this.name = cause && cause.name ? cause.name : 'NetworkError';
        this.statusCode = statusCode;
        this.skipSentry = typeof skipSentry === 'boolean' ? skipSentry : $54c275f50bd3d999$var$is4xxError(statusCode);
    }
}
const $54c275f50bd3d999$export$a7a3f8c4788fb03d = (id, error, errorAttrs = {})=>{
    const options = {
        error: error,
        meta: {
            id: id,
            packageName: 'jiraConnect'
        },
        attributes: {
            skipSentry: error.skipSentry,
            statusCode: error.statusCode,
            ...errorAttrs
        },
        sendToPrivacyUnsafeSplunk: true,
        skipSentry: error.skipSentry
    };
    (0, $guiFP.default)(options);
    if (error.cause) (0, $guiFP.default)({
        ...options,
        attributes: {
            ...options.attributes,
            isInnerError: true
        },
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        error: error.cause
    });
};

});


parcelRegister("ds7fh", function(module, exports) {

var $chRvw = parcelRequire("chRvw");
module.exports = $chRvw("dJtVb").then(()=>parcelRequire('l6TcI'));

});



parcelRegister("jLerq", function(module, exports) {

$parcel$export(module.exports, "EcosystemModuleAsync", () => $ec457b27842b5036$export$75ae776ec6b96bba);
$parcel$export(module.exports, "EcosystemTimeoutViewAsync", () => $ec457b27842b5036$export$c800b42cc8eabb03);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $ec457b27842b5036$var$EcosystemModule = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("3c7qd")), {
    ssr: true,
    moduleId: "./src/packages/connect-utils/connect-utils-async/src/index.tsx"
});

const $ec457b27842b5036$var$EcosystemTimeoutView = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("epegH")), {
    ssr: true,
    moduleId: "./src/packages/connect-utils/connect-utils-async/src/common/ui/ecosystem-timeout-view/index.tsx"
});
const $ec457b27842b5036$export$75ae776ec6b96bba = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "ecosystem-module-async",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ec457b27842b5036$var$EcosystemModule, props));
const $ec457b27842b5036$export$c800b42cc8eabb03 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "ecosystem-timeout-view-async",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ec457b27842b5036$var$EcosystemTimeoutView, props));

});
parcelRegister("3c7qd", function(module, exports) {

var $chRvw = parcelRequire("chRvw");
module.exports = $chRvw("b9Lnk").then(()=>parcelRequire('7OLHR'));

});

parcelRegister("epegH", function(module, exports) {

var $chRvw = parcelRequire("chRvw");
module.exports = $chRvw("fJUCR").then(()=>parcelRequire('4Ep9I'));

});


// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("9IbuV", function(module, exports) {

$parcel$export(module.exports, "useUFOComponentExperience", () => $dfcd8ff9c232688c$export$30ab340faaed55d4);

var $eUqFw = parcelRequire("eUqFw");
const $dfcd8ff9c232688c$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $eUqFw.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $dfcd8ff9c232688c$export$30ab340faaed55d4 = (experience)=>{
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $dfcd8ff9c232688c$var$useConstructor(()=>experience.start());
    return null;
};

});


parcelRegister("pljWC", function(module, exports) {

$parcel$export(module.exports, "ForgeBackgroundScript", () => $2aee6c5794b3d41d$export$e71a867cc455d1dd);

var $eUqFw = parcelRequire("eUqFw");

var $1ldMC = parcelRequire("1ldMC");
const $2aee6c5794b3d41d$export$e71a867cc455d1dd = ({ item: item })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ldMC.AsyncDashboardBackgroundScript), {
        extension: item,
        extensionData: {}
    });

});
parcelRegister("1ldMC", function(module, exports) {

$parcel$export(module.exports, "AsyncDashboardBackgroundScript", () => $f912ce729ff95515$export$a49bc38bf8ed3880);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $gamHX = parcelRequire("gamHX");

var $2vJHJ = parcelRequire("2vJHJ");

var $bL3M0 = parcelRequire("bL3M0");
const $f912ce729ff95515$export$a49bc38bf8ed3880 = (props)=>{
    const { extensionData: extensionData, ...restProps } = props;
    const extraProps = {
        module: (0, $2Rqjr.DASHBOARD_BACKGROUND_SCRIPT_MODULE),
        extensionData: {
            ...extensionData,
            type: (0, $2Rqjr.DASHBOARD_BACKGROUND_SCRIPT_MODULE)
        }
    };
    if (!(0, $2vJHJ.isCustomUIExtension)(props.extension)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bL3M0.InvisibleDiv), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gamHX.LazyIframe), {
        ...restProps,
        ...extraProps
    }));
};

});
parcelRegister("gamHX", function(module, exports) {

$parcel$export(module.exports, "LazyIframe", () => $06c11067a462069c$export$808646051d5a3908);
$parcel$export(module.exports, "LazyModalIframe", () => $06c11067a462069c$export$f35ac420e260eb7);

var $7rh0R = parcelRequire("7rh0R");

var $1boRu = parcelRequire("1boRu");

const $06c11067a462069c$var$getModule = ()=>(parcelRequire("7lalf"));
const $06c11067a462069c$export$808646051d5a3908 = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazyForPaint)(()=>$06c11067a462069c$var$getModule().then((module)=>module.IframeRenderer), {
    ssr: false
}));
const $06c11067a462069c$export$f35ac420e260eb7 = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazy)(()=>$06c11067a462069c$var$getModule().then((module)=>module.ModalIframeRenderer), {}));

});
parcelRegister("7lalf", function(module, exports) {

var $chRvw = parcelRequire("chRvw");
module.exports = Promise.all([
    $chRvw("2hmUs"),
    $chRvw("bCeK4"),
    $chRvw("h2MrD"),
    $chRvw("bYT2S"),
    $chRvw("8ficv")
]).then(()=>parcelRequire('kq5KC'));

});


parcelRegister("bL3M0", function(module, exports) {

$parcel$export(module.exports, "InvisibleDiv", () => $3b2b331dada7ea6a$export$22ef238a7bbeac70);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $3b2b331dada7ea6a$export$22ef238a7bbeac70 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3b2b331dada7ea6a$var$StyledInvisibleDiv, null, children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3b2b331dada7ea6a$var$StyledInvisibleDiv = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});





//# sourceMappingURL=async-jira-dashboard-background-scripts.916717b7.js.map
